import { Dataset, Description } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import { datatypes, inputTypes } from "data/globalData";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import DiscountIcon from "@mui/icons-material/Discount";
import StorefrontIcon from '@mui/icons-material/Storefront';
import ApprovalIcon from '@mui/icons-material/Approval';

export const mboPaymentDashboardServices = {
	masters: {
		name: "Discount",
		key: "discount",
		display: true,
		icon: <DiscountIcon />,
		types: {
			discount_master: {
				name: "Discount Master",
				key: "discount_master",
				display: true,
				icon: <FormatListBulletedIcon />,
			},
			create_discount: {
				name: "Create Discount",
				key: "create_discount",
				display: false,
				icon: <FormatListBulletedIcon />,
			},
			discount_summary: {
				name: "Discount Summary",
				key: "discount_summary",
				display: false,
				icon: <FormatListBulletedIcon />,
			},
			nod: {
				name: "NOD",
				key: "nod",
				display: true,
				icon: <AddIcon />,
			},
		},
	},
	master: {
		name: "Master",
		key: "master",
		display: true,
		icon: <Dataset />,
		types: {
			store_master: {
				name: "Store Master",
				key: "store_master",
				display: true,
				icon: <StorefrontIcon />,
			},
			approval_master: {
				name: "Approval Master",
				key: "approval_master",
				display: true,
				icon: <ApprovalIcon />,
			},
		},
	},
};

// Scheme fields.
export const schemeTableColumns = [
	{
		name: "Scheme Name",
		key: "scheme_name",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
	},
	{
		name: "Scheme Description",
		key: "scheme_description",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
	},
];

// store selection fields.
export const storeSelectionColumns = [
	{
		name: "Distributer / Partner",
		key: "distributer_partner",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		// option_data: {
		// 	type: arrType,
		// 	list: storeLiscenceTypes,
		// 	getOptionLabel: (row) => {
		// 		return { name: row.label, key: row.value };
		// 	},
		// },
	},
	{
		name: "State",
		key: "state",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		// option_data: {
		// 	type: arrType,
		// 	list: storeLiscenceTypes,
		// 	getOptionLabel: (row) => {
		// 		return { name: row.label, key: row.value };
		// 	},
		// },
	},
	{
		name: "Store Name",
		key: "store_name",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		// option_data: {
		// 	type: arrType,
		// 	list: storeLiscenceTypes,
		// 	getOptionLabel: (row) => {
		// 		return { name: row.label, key: row.value };
		// 	},
		// },
	},
];
